(() => {
  class EnterPaymentCtrl {
    constructor($rootScope, $timeout, toastr, Notifications) {
      'ngInject';

      angular.extend(this, {
        $rootScope,
        $timeout,
        toastr,
        Notifications,
        paymentOptions: [{
          name: 'Credit Card',
          value: 'creditcard',
          selected: true // WE TEMPORARILY REMOVE PAYPAL FROM WEB (uncomment)
          // }, {
          //   name: 'Paypal',
          //   value: 'paypal',
          //   selected: false,

        }]
      });
    }

    $onInit() {
      this.paymentType = 'creditcard';
      this.saveOnPayment = true;
    }

    $onChanges(changes) {
      /* Errors passed from our payment server */
      if (changes.errors) {
        this.errors = angular.copy(this.errors);
      }
    }

    changePaymentType() {
      this.errors = [];
    }

    onPaypalSuccess(nonce, email) {
      this.$rootScope.$apply(() => {
        this.paypalNonce = nonce;
        this.paypalEmail = email;
      });
    }

    onPaypalCancelled() {
      this.$rootScope.$apply(() => {
        this.paypalNonce = null;
        this.paypalEmail = null;
      });
    }

    onPaypalPayment() {
      const details = {
        nonce: this.paypalNonce,
        paypalEmail: this.paypalEmail
      };
      this.onPaymentMethodReceived(details);
    }

    onPaymentMethodReceived(data) {
      data.saveOnPayment = this.saveOnPayment;
      this.onSubmit({
        data
      });
    }

    onStripePayment(data) {
      const details = {
        setupIntent: data.setupIntent
      };
      this.onPaymentMethodReceived(details);
    }

    onElavonPayment(data) {
      const details = {
        token: data.token
      };
      this.onPaymentMethodReceived(details);
    }

  }

  EnterPaymentCtrl.$inject = ["$rootScope", "$timeout", "toastr", "Notifications"];
  angular.module('pims').component('enterPayment', {
    templateUrl: 'app/components/payments/enterPayment.html',
    controller: EnterPaymentCtrl,
    bindings: {
      onSubmit: '&',
      errors: '=',
      userId: '<',
      paymentInProcess: '<',
      paymentProvider: '<'
    }
  });
})();
